<template>
  <div class="lp-wave-content">
    <div class="lp-wave-login ly-row ly-center-center">
      <div class="ly-col ly-center-center callback-wrapper" v-load-fade-in="{ delay: 0, timeBetween: 0 }">
        <div v-show="true" class="callback-card lp-load-fadein">
      <h2>OAuth Callback</h2>
      <p class="subtitle">Received redirect payload</p>

      <section v-if="queryParams.length">
        <h3>Query Parameters</h3>
        <table>
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="param in queryParams" :key="param.key">
              <td class="key">{{ param.key }}</td>
              <td class="value">{{ param.value }}</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section v-if="!queryParams.length">
        <p class="empty">No parameters received.</p>
      </section>

      <section class="raw">
        <h3>Raw URL</h3>
        <code>{{ fullUrl }}</code>
      </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

interface Param {
  key: string
  value: string
}

const queryParams = ref<Param[]>([])
const fullUrl = ref('')

onMounted(() => {
  fullUrl.value = window.location.href

  // Parse query string
  const urlParams = new URLSearchParams(window.location.search)
  urlParams.forEach((value, key) => {
    queryParams.value.push({ key, value })
  })
})
</script>

<style scoped>
.callback-wrapper {
  background: transparent !important;
}

.callback-card {
  background: #fff;
  border-radius: 8px;
  padding: 2rem;
  max-width: 720px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

h2 {
  margin: 0 0 0.25rem;
  color: #1a2332;
}

.subtitle {
  color: #6b7280;
  margin: 0 0 1.5rem;
}

h3 {
  margin: 1.25rem 0 0.5rem;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #4b5563;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

th, td {
  text-align: left;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #e5e7eb;
}

th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
}

.key {
  font-family: monospace;
  color: #7c3aed;
  white-space: nowrap;
}

.value {
  font-family: monospace;
  word-break: break-all;
  color: #111827;
}

.empty {
  color: #9ca3af;
  font-style: italic;
}

.raw {
  margin-top: 1.5rem;
}

.raw code {
  display: block;
  background: #f3f4f6;
  padding: 0.75rem;
  border-radius: 4px;
  font-size: 0.8rem;
  word-break: break-all;
  color: #1f2937;
}
</style>
